var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbank30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1091_5965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "#120063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5549 21.4868H9.64765L8.21116 23.1501V21.4868H7.48535V25.1158H8.21116V23.4525L9.69301 25.1158H10.6003L8.98233 23.3013L10.5549 21.4868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3388 22.515C12.0364 22.515 11.7793 22.6511 11.5676 22.8326V21.4868H10.8418V23.8759C10.8418 24.6017 11.3257 25.2066 12.2178 25.2066C13.0192 25.2066 13.5938 24.6471 13.5938 23.8759C13.5787 23.135 13.0948 22.515 12.3388 22.515ZM12.2027 24.5564C11.8247 24.5564 11.5222 24.254 11.5222 23.891V23.8759C11.5222 23.8003 11.5374 23.7247 11.5525 23.6491C11.6432 23.3769 11.9003 23.1804 12.2027 23.1804C12.5807 23.1804 12.8831 23.4828 12.8831 23.8608C12.8831 24.2388 12.5807 24.5564 12.2027 24.5564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6903 22.5151C18.3425 22.5151 18.0703 22.6361 17.8586 22.8327V22.5907H17.1328V24.4506V25.1159H17.8435H17.8586V23.6946C17.8586 23.4073 18.1006 23.1653 18.3879 23.1653C18.6751 23.1653 18.9171 23.4073 18.9171 23.6946V25.1008V25.1159H19.6429V23.498C19.6429 23.4829 19.6429 23.4829 19.6429 23.4678C19.658 22.9385 19.2195 22.5151 18.6903 22.5151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3032 22.5151C14.4867 22.5151 13.9121 23.0746 13.9121 23.8458C13.9121 24.5867 14.4111 25.1915 15.1672 25.1915C15.5149 25.1915 15.8476 25.0101 16.029 24.753V25.1008H16.6792V23.8307C16.6792 23.8155 16.6792 23.8155 16.6792 23.8155C16.6944 23.12 16.2105 22.5151 15.3032 22.5151ZM15.3184 24.5413C14.9403 24.5413 14.6379 24.2389 14.6379 23.8609C14.6379 23.4829 14.9403 23.1805 15.3184 23.1805C15.6964 23.1805 15.9988 23.4829 15.9988 23.8609C16.0139 24.2389 15.7115 24.5413 15.3184 24.5413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.516 25.0856L21.4273 23.8306L22.4858 22.5906H21.6995L20.7922 23.6642V21.4717H20.0664V25.0856H20.7922V23.9969L21.7297 25.0856H22.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4758 7.10697L15 10.5243L10.5242 7.10697L7.5 4.79346V8.48297V19.3852H10.5242V10.8267L15 14.3045L19.4758 10.8267V19.3852H22.5V8.48297V4.79346L19.4758 7.10697Z",
    fill: "#BCF100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1091_5965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbank30);
export default __webpack_public_path__ + "static/media/Kbank-30.b4ff3385d5b49de249548893b6a87fcd.svg";
export { ForwardRef as ReactComponent };